export default {
  /**
   * 分類条件の標準フォーマット
   */
  get(outputColumns = []) {
    return {
      /**
       * 説明
       */
      description: undefined,
      /**
       * 企業コード
       */
      company: undefined,
      /**
       * ジャーナルタイプ
       */
      type: 'idpos',
      /**
       * 出力項目
       */
      outputColumns: outputColumns
        .filter(f => f.idpos && f.isDefault)
        .map(m => m.key),
      /**
       * 追加ダウンロード
       */
      optionalDownloads: [],
      /**
       * 入力エラー
       */
      errors: [],
    }
  },
  /**
   * 分析APIで使用するフォーマットに変換する
   */
  mapToApiPayload(basic) {
    return {
      description: basic.description,
      company: basic.company,
      type: basic.type,
      optionalDownloads: basic.optionalDownloads,
      outputColumns: basic.outputColumns,
    }
  },
  /**
   * basic
   */
  applyPayload(applyTo, basic) {
    applyTo.description = basic.description
    applyTo.company = basic.company
    applyTo.type = basic.type
    applyTo.optionalDownloads = basic.optionalDownloads
    applyTo.outputColumns = basic.outputColumns
  },
  summaryTextForOutputColumns(storeOutputColumns, queryFilter) {
    if (queryFilter.outputColumns) {
      return storeOutputColumns
        .filter(f => queryFilter.outputColumns.includes(f.key))
        .map(m => m.label)
        .join(', ')
    } else {
      if (queryFilter.type === 'idpos') {
        return storeOutputColumns
          .filter(f => f.isDefault && f.idpos)
          .map(m => m.label)
          .join(', ')
      } else {
        return storeOutputColumns
          .filter(f => f.isDefault && f.pos)
          .map(m => m.label)
          .join(', ')
      }
    }
  },
}
